<template>
<main class="main-wrapper flex-grow-1 bg-documentGray vh-100">
		<div class="d-flex align-items-center bg-white">
			<div v-if="type === 'formal-evolution'" class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m ">
						{{$t('1230')}}
			</div>
      <div v-else-if="type === 'regular-evolution'" class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
						{{$t('1231')}}
			</div>
      <div v-else class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
						{{$t('1232')}}
			</div>
			<div class="mgr-24 right-button">
				<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0" type="button" @click="routerGoPrev(examActions)">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-color-iconActive font-r">{{$t('3311')}}</span>
				</button>
			</div>
		</div>
		<div class="divider"></div>

		<div class="container container--narrow pdt-50">
      <div class="mgt-50">
        <div class="mdc-card pdt-40 pdb-36 pdl-36 pdr-36">
          <div class="d-flex">
            <div>
              <img alt="" class="icon62" src="../../images/test_guid_icon.svg">
            </div>
            <div class="pdl-22 flex-grow-1 d-flex flex-column ">
              <div class="t-headline11 font-m t-line-h-36 l-spacing72">{{examName}}</div>
                <div class="divider mgt-32 mgb-30"></div>
              <div class="mgt-2 d-grid-2-16 ">
                <div class="pdl-13 position-relative bullet-list  d-flex align-items-center">
                  <span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{$t('1233')}}</span>
                  <span class="t-body1 font-b pdr-8 t-uppercase">{{examLevel || '-'}}</span>
                </div>
                <div class="pdl-13 position-relative bullet-list  d-flex align-items-center">
                  <span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{$t('1234')}}</span>
                  <span class="t-body1 font-b pdr-8">{{examQuestionCount}}</span>
                </div>
                <div class="pdl-13 position-relative bullet-list  d-flex align-items-center">
                  <span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{$t('1235')}}</span>
                  <span class="t-body1 font-b pdr-8 t-uppercase">{{examRetakeStatus}}</span>
                </div>
                <div class="pdl-13 position-relative bullet-list  d-flex align-items-center">
                  <span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{$t('1238')}}</span>
                  <span v-if="!examAverageTime" class="t-headline9 t-line-h-29 font-rb t-center ">
                    <span>-</span>
                  </span>
                  <span v-else class="t-body1 t-line-h-29 font-b">{{examAverageMin}}<span class="pdl-1 t-body3 font-r">{{$t('1236')}}</span>
                    <span class="pdl-6 font-b">{{examAverageSec}}</span>
                    <span class="pdl-1 t-body3 font-r">{{$t('1237')}}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
					<div class="mgt-50">
							<div v-for="(action, index) in examActions" :key="index" class="">
											<button v-if="action.action === 'can_start' || action.action === 'can_re_start'"
											:disabled="setButtonDisabled(action)" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 w-full" tabindex="0" @click="examAction(action)">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
											</button>
											<button
													v-else :disabled="setButtonDisabled(action)" class="mgt-16 mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText b-radius4 w-full" tabindex="0" @click="examAction(action)">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
											</button>
							</div>
						</div>
		</div>
</main>
</template>

<script>
/**
 * 시험 응시 인트로 컴포넌트(exam take intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import microExamApi from "@/api/microExamApi";
import microLearnApi from "@/api/microLearnApi";
import {MDCRipple} from '@material/ripple';
import {examMixin} from "@/mixins/exam";

export default {
	name: 'examContainer',

  mixins: [examMixin],

	data() {
		return {
			examData: null,
			examTitle: '',
			examName : '',
			examLevel : '',
			examNumber : '',
			examRetake : '',
			examAverageMin : 0,
			examAverageSec : 0,
			examAverageTime: 0,
			examQuestionCount: 0,
			progressionValue: '',

			examSubmit: false,
			examCanStart: false,
			examOpenScore: false,

			examActions: [],
			type: null
		}
	},

	created() {
		this.fatchData()
	},

	computed: {
		setTitle() {
			return this.examTitle || 'TEST';
		},

		examRetakeStatus() {
			return this.examRetake === 'ONCE' ? 'IMPOSSIBLE' : 'POSSIBLE';
		}
	},

	mounted() {
		this.type = this.$route.query.type;
		this.setMaterialUi();
	},

	methods: {
		// set data
		async fatchData() {
			if (this.$route.params.learnId) {
                await microLearnApi.openNextLearning(this.$route.params.learnId);
            }
			let params = this.setParams();
			// call api exam intro
      		microExamApi.examIntro(params).then((response) => {
				this.examData = response.data.data;
				this.examName = this.examData.name
				this.examLevel = this.examData.level ? this.examData.level.text : ''
				this.examNumber = this.examData.submitCount
				this.examRetake = this.examData.applicationTerms.value
				this.examAverageTime = this.examData.avgSolveTime
				this.examAverageMin = Math.floor(this.examData.avgSolveTime / 60)
				this.examAverageSec = this.examData.avgSolveTime - this.examAverageMin * 60
				this.examQuestionCount = this.examData.activityCount.question
				this.examSubmit = this.examData.submit
				this.examCanStart = this.examData.canStart
				this.examOpenScore = this.examData.openScore
				this.examActions = this.examData.actions
				this.examActions.push()
			}).catch((err) => {})
		},

		// API 호출 파라미터 설정(set parameter)
		setParams() {
      let params = {
        examineeId: this.$route.params.examineeId
			}
			return params
		},

		setButtonActionName(action) {
			//before_start : ~부터 응시가능
			//can_start : 응시
			//can_re_start : 재응시
			//before_confirm : ~부터 결과확인 가능
			//open_confirm : 결과확인
			let buttonName = ''
			if (action.action === 'before_start') {
				buttonName = this.$t('50010', {str: action.data.application_start_time}) //  + '{날짜}부터 응시가능'
			}else if (action.action === 'can_start') {
				buttonName = this.$t('1239') //'응시'
			}else if (action.action === 'can_re_start') {
				buttonName = this.$t('1262') //재응시'
			}else if (action.action === 'before_confirm') {
				buttonName = this.$t('50011', {str: action.data.confirm_start_time}) // '~부터 결과확인 가능'
			}else if (action.action === 'open_confirm') {
				buttonName = this.$t('1263') //'결과확인'
			}
			return buttonName
		},

		setButtonDisabled(action) {
			return action.action === 'before_start' || action.action === 'before_confirm'
		},

		examAction(action) {
      if(this.examQuestionCount === 0) {
        this.$alert({
          // TODO: 다국어 코드 추가
          content: '시험 문항 준비 중입니다',
          accept:  this.$t('1592'),
        }).then(() => {});
        return;
      }
			if (action.action === 'can_start' || action.action === 'can_re_start') {
				// 시험응시(exam take)
				this.startExam()
			} else if (action.action === 'open_confirm') {
				// 시험결과로 이동(move exam result)
				this.moveExamResult()
			}
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

    // 시험 시작(Start Exam)
    startExam() {
      let routeName = '';
      if (this.isIndependentExamTake()) {
        if (this.isIndependentExamReTake()) {
          routeName = 'IndependentExamResultTake'
        } else {
          routeName = 'IndependentExamTake'
        }
      } else if (this.isLessonExamTake()) {
        routeName = 'MicroExamTake'
      } else if (this.isFinalExamTake()) {
        routeName = 'FinalMicroExamTake'
      }
      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      })
    },

    // 시험 결과로 이동(move exam result)
    moveExamResult() {
      let routeName = ''
      if (this.isIndependentExamTake()) {
        routeName = 'IndependentExamResultView'
      }else if (this.isLessonExamTake()) {
        routeName = 'MicroExamResult'
      }else if (this.isFinalExamTake()) {
        routeName = 'FinalMicroExamResult'
      }

      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      })
    },

    // 형성평가 시험 응시 확인(check lesson exam)
    isLessonExamTake() {
      let routeName = this.$route.name
      return routeName.indexOf('MicroExam') >= 0
    },

    // 정규평가 시험 응시 확인(check final exam)
    isFinalExamTake() {
      let routeName = this.$route.name
      return routeName.indexOf('FinalMicro') >= 0
    },

    routerGoPrev() {
      this.$router.push({
        name: "MicroDegreeView",
        params: this.$route.params.learnId,
        query: {status:this.$route.query.status},
      });
    },
	},
}

</script>
